import React, { useContext } from "react";
import styles from '../individualWorkPlan.module.css';
import { IndividualWorkPlanContext } from "../../../utils/context";
import { useSelector } from "react-redux";


export default function YearBudget() {

  const { academicWorkTimes } = useSelector(state => state.individualWorkPlan)
  const { id, filteredItemsYearBudget } = useContext(IndividualWorkPlanContext)

  const head = (Object.entries(filteredItemsYearBudget).map(([key, value]) => key.length === 0 && value)).find(el => el.length)
  const body = (Object.entries(filteredItemsYearBudget).filter(([key, value]) => key.length !== 0))
  
  return (
    <>
      <div className="table">
        {/* {filteredItemsYearBudget && filteredItemsYearBudget.staff.length ? ( */}
        <div style={{ fontSize: '13px', width: '100%' }}>
          <p>1. Годовой бюдет служебного (рабочего) времени - {academicWorkTimes?.[1]?.[0]?.sum} часов.</p>
          <p>2. Годовой бюджет времени на учебную, методическую, научную (научно-исследовательскую) и воспитательную работы - {academicWorkTimes?.[2]?.[0]?.plan} часов.</p>
          <p>3. Учебная нагрузка, установленная приказом начальника ВУЗа от {academicWorkTimes?.[3]?.[0]?.orderdate} № {academicWorkTimes?.[3]?.[0]?.prikaz} - {academicWorkTimes?.[3]?.[0]?.total} часов, в том числе на проведение аудиторных занятий - { academicWorkTimes?.[3]?.[0]?.lesson } часа</p>
          <p>4. Время на профессионально-должностную подготовку и другие виды деятельности - {academicWorkTimes?.[4]?.[0]?.plan} часов</p>
        </div>

        <p>Распределение времени по семестрам и основным видам деятельности</p>
        <table className="tg-second">
          <thead>
            <tr>
              <th className="tg-yw4l" rowSpan={3}>№ п/п</th>
              <th className="tg-yw4l" rowSpan={3} style={{ width: '300px' }}>Основные виды деятельности</th>
              <th className="tg-yw4l" colSpan={6}>Объем деятельности в часах</th>
            </tr>
            <tr>
              <th className={styles.table23} colSpan={2}>I семестр</th>
              <th className={styles.table23} colSpan={2}>II семестр</th>
              <th className={styles.table23} colSpan={2}>Учебный год</th>
            </tr>
            <tr>
              <th className={styles.table23}>по плану</th>
              <th className={styles.table23}>выполнено</th>
              <th className={styles.table23}>по плану</th>
              <th className={styles.table23}>выполнено</th>
              <th className={styles.table23}>по плану</th>
              <th className={styles.table23}>выполнено</th>
            </tr>
          </thead>
          <tbody>
            {head?.map((el, i) => {
              const { name, plan_1, fact_1, plan_2, fact_2, s_fact, s_plan } = el
              let col = 1
              const inside = body.map(el =>

                name === el[0] && (
                  el[1].map(ele =>
                  (
                    col = col + 1,
                    <tr>
                      <td >{ele.name}</td>
                      <td>{ele.plan_1}</td>
                      <td>{ele.fact_1}</td>
                      <td>{ele.plan_2}</td>
                      <td>{ele.fact_2}</td>
                      <td>{ele.s_fact}</td>
                      <td>{ele.s_plan}</td>
                    </tr>
                  )
                  )

                )


              )

              return (
                <>
                  < tr >
                    <td rowSpan={col}>{i + 1}</td>
                    <td >{name}</td>
                    <td>{plan_1}</td>
                    <td>{fact_1}</td>
                    <td>{plan_2}</td>
                    <td>{fact_2}</td>
                    <td>{s_fact}</td>
                    <td>{s_plan}</td>
                  </tr>
                  {inside}
                </>

              )
            }
            )
            }
          </tbody>

        </table>
        {/* ) : (
          <NoData text="данные отсутствуют" />
        )} */}
      </div >
      {!filteredItemsYearBudget && <div className="div__buttons">
        <div className="buttons__edit">Изменить</div>

      </div>
      }
    </>
  );
}
